/* eslint-disable no-unused-vars */
// Mirrors the backend policy names (`Policy.Names` in the EXO API). Values must
// match the backend exactly — checked against `user.policies` from /User/me.
export enum Policies {
  // Relevant to the frontend: gate admin UI pages/actions.
  // (StationReset is action-level — the Stations "reset" endpoint.)
  Administrator = 'Administrator',
  SuperAdmin = 'SuperAdmin',
  StoreManager = 'StoreManager',
  FloorManager = 'FloorManager',
  Clerk = 'Clerk',
  TunnelManager = 'TunnelManager',
  LossDetection = 'LossDetection',
  StationReset = 'StationReset',

  // Not used for UI gating: service-account / internal policies, kept only for
  // parity with the backend catalog.
  ExternalService = 'ExternalService',
  InternalOrExternalService = 'InternalOrExternalService',
  InternalService = 'InternalService',
  StationService = 'ExoStation-ActAsInternalService'
}
